'use client';

import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import type { FC, ReactElement } from 'react';
interface PointsToTokensCardSkeletonProps {
  className?: string;
}
const cvaPointsToTokensCard = cva(['PointsToTokensCardSkeleton', 'relative flex w-full justify-between overflow-hidden', 'rounded-2xl border border-[#4345644D] bg-[#000000] lg:bg-[#0000004D] backdrop-blur-sm', 'animate-pulse']);
export const PointsToTokensCardSkeleton: FC<PointsToTokensCardSkeletonProps> = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(cvaPointsToTokensCard(), className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="z-[1] flex flex-1 flex-col px-5 py-6 2md:px-8 2md:py-8"><div className="h-[14px] w-[120px] rounded bg-white/20 2md:h-[22px] 2md:w-[180px]" /><div className="mt-1 h-[48px] w-[180px] rounded bg-white/20 2md:h-[62px] 2md:w-[240px]" /><div className="mt-[34px] h-[14px] w-[100px] rounded bg-white/20 md:mt-8 2md:h-[22px] 2md:w-[150px]" /><div className="mt-1 h-[48px] w-[160px] rounded bg-white/20 2md:h-[56px] 2md:w-[200px]" /></div>;
    t3 = <div className="pointer-events-none absolute inset-y-0 right-0 h-full w-[260px] bg-white/5 2md:w-[320px]" aria-hidden="true" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <article className={t1}>{t2}{t3}</article>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
PointsToTokensCardSkeleton.displayName = 'PointsToTokensCardSkeleton';
export type { PointsToTokensCardSkeletonProps };